import { createContext, useMemo, useState } from 'react';
import {
  FavoriteRequestBody,
  FavoriteVehicle
} from '~/services/favoritesService';
import useLoadableFavorites from './useLoadableFavorites';

type FavoritesContextType = {
  addFavorite: (payload: FavoriteRequestBody) => void;
  favorites: FavoriteVehicle[];
  isLoading: boolean;
  modalVehicleId: number;
  removeFavorite: (payload: FavoriteRequestBody) => void;
  setModalVehicleId: (modalVehicleId: number) => void;
  triggerFetchFavorites: () => void;
};

const defaultContext: FavoritesContextType = {
  addFavorite: _value => {},
  favorites: [],
  isLoading: false,
  modalVehicleId: 0,
  removeFavorite: _value => {},
  setModalVehicleId: _value => [],
  triggerFetchFavorites: () => {}
};

const FavoritesContext = createContext<FavoritesContextType>(defaultContext);

export function FavoritesContextProvider({ children }) {
  const [modalVehicleId, setModalVehicleId] = useState(0);

  const {
    addFavorite,
    favorites,
    isLoading,
    removeFavorite,
    triggerFetchFavorites
  } = useLoadableFavorites();

  const value = useMemo<FavoritesContextType>(
    () => ({
      addFavorite,
      favorites,
      isLoading,
      modalVehicleId,
      removeFavorite,
      setModalVehicleId,
      triggerFetchFavorites
    }),
    [
      addFavorite,
      favorites,
      isLoading,
      modalVehicleId,
      removeFavorite,
      triggerFetchFavorites
    ]
  );

  return (
    <FavoritesContext.Provider value={value}>
      {children}
    </FavoritesContext.Provider>
  );
}

FavoritesContextProvider.displayName = 'FavoritesContextProvider';

export default FavoritesContext;
